// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 195 ? "bf5f3635" : chunkId) + "." + {"195":"0ed6ac1c2119a6fb","268":"8eee1d888e2c46d2","647":"bdf51f852ecac447"}[chunkId] + ".js";
};